export default (dt) => {
  const dateObj = new Date(dt);
  const options = { weekday: 'short', month: 'short', day: '2-digit' };

  return dateObj.toLocaleDateString(undefined, options);
};
